import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { EditConditionLinkContent } from './components/EditConditionLinkContent';
import { useSearchParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { PageWithLayout } from '@/models/page';
import { Permission } from '@/models/user';

const EditConditionLink: PageWithLayout = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const importId = searchParams.get('importId');

    return (
        <Box>
            <Helmet>
                <title>Regelwerk Bearbeiten | Starjack Admin</title>
            </Helmet>

            {!!id && <EditConditionLinkContent id={id} importId={null} />}

            {!id && !!importId && (
                <EditConditionLinkContent id={null} importId={importId} />
            )}
        </Box>
    );
};

EditConditionLink.isProtected = true;
EditConditionLink.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
EditConditionLink.permissions = [Permission.CONDITION_LINKS_NAV];

export default EditConditionLink;
